import gql from "graphql-tag";

export const GET_REMOTE_EQUIPMENT = gql`
  query getRemoteEquipment {
    getRemoteEquipment {
      id
      description
    }
  }
`;